import { render } from "./BrandLayout.vue?vue&type=template&id=6a2162e2"
import script from "./BrandLayout.vue?vue&type=script&lang=js"
export * from "./BrandLayout.vue?vue&type=script&lang=js"

import "./BrandLayout.vue?vue&type=style&index=0&id=6a2162e2&lang=css"
import "./BrandLayout.vue?vue&type=style&index=1&id=6a2162e2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__